var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.showDisclaimer)?_c('button',{staticClass:"tooltip disclaimer-button",on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _setup.openDisclaimer.apply(null, arguments)}}},[_c('img',{attrs:{"src":"/appassets/img/info-icon-dark.svg","height":"16","alt":"info"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }